import React from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack5";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

const Pdf = ({ paramsDocument, paramsPage }) => {
  return (
    <Document {...paramsDocument}>
      <Page {...paramsPage} pageIndex={0} renderMode="canvas"></Page>
    </Document>
  );
};

export default Pdf;
